import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_PM_CLIENT_PHOTOS_API } from "./apiRoutes";

interface Props {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getClientPhotos = async (projectId: string) => {
  return await axiosAuth.get(`${DASHBOARD_PM_CLIENT_PHOTOS_API(projectId)}`);
};

const useGetPmClientPhotos = ({ projectId, queryParams }: Props): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-client-photos", projectId],
    queryFn: () => getClientPhotos(projectId),
    select: (data: any) => data.data.data,
    refetchOnWindowFocus: false,
    enabled: !!projectId,
    ...queryParams,
  });
};

export default useGetPmClientPhotos;
